document.addEventListener('DOMContentLoaded', function () {
  var settings = window.popupPromoSettings || {};
  
  // 1. Load Data
  var dataScript = document.getElementById('offers-hub-data');
  if (!dataScript) return;
  
  var offers = [];
  try {
    offers = JSON.parse(dataScript.textContent);
  } catch (e) {
    console.error("Could not parse offers data", e);
    return;
  }
  
  if (offers.length === 0) return;

  // 2. Track Truly Paid Offers (from Backend)
  var usedCodesScript = document.getElementById('customer-used-codes');
  var usedCodes = [];
  if (usedCodesScript) {
    try {
      usedCodes = JSON.parse(usedCodesScript.textContent);
    } catch (e) {}
  }

  // Determine which offers are claimed based on if their discount_code exists in usedCodes
  var claimedOffers = offers.filter(o => o.discount_code && usedCodes.includes(o.discount_code)).map(o => o.id);

  // Save claimed offers to localStorage so we remember even if the user logs out or closes the browser
  claimedOffers.forEach(function(id) {
    localStorage.setItem('claimed_offer_' + id, 'true');
  });

  // Restore claimed offers from localStorage
  offers.forEach(function(o) {
    if (localStorage.getItem('claimed_offer_' + o.id) === 'true' && !claimedOffers.includes(o.id)) {
      claimedOffers.push(o.id);
    }
  });

  // 3. UI Elements
  var widget = document.getElementById('offers-hub-widget');
  var badge = document.getElementById('offers-hub-badge');
  var drawer = document.getElementById('offers-hub-drawer');
  var drawerList = document.getElementById('offers-hub-drawer-list');
  var closeDrawerBtn = document.querySelector('.offers-hub-close');
  var drawerOverlay = document.querySelector('.offers-hub-drawer-overlay');
  
  // Popups logic
  var popups = document.querySelectorAll('.popup_promo_overlay');
  var activePopup = null;

  // 4. Drawer & Widget Logic
  function updateWidget() {
    var unclaimedCount = offers.filter(o => !claimedOffers.includes(o.id)).length;
    if (widget && badge) {
      widget.style.display = 'flex';
      badge.textContent = unclaimedCount;
    }
  }

  function toggleDrawer(forceClose) {
    if (forceClose || document.body.classList.contains('offers-drawer-open')) {
      document.body.classList.remove('offers-drawer-open');
    } else {
      renderDrawerList();
      document.body.classList.add('offers-drawer-open');
    }
  }

  if (widget) widget.addEventListener('click', () => toggleDrawer());
  if (closeDrawerBtn) closeDrawerBtn.addEventListener('click', () => toggleDrawer(true));
  if (drawerOverlay) drawerOverlay.addEventListener('click', () => toggleDrawer(true));

  // Render a single offer card HTML
  function getOfferCardHTML(offer, isClaimed) {
    var badgeHTML = isClaimed ? `<div class="offer-card-claimed-badge">Claimed</div>` : '';
    var codeSection = '';
    
    if (offer.discount_code) {
      if (isClaimed) {
        codeSection = `
          <div style="margin-top: 10px; font-size: 0.85rem; color: var(--text-on-light-muted);">
            Code used: <strong style="color: var(--brand-ink);">${offer.discount_code}</strong>
          </div>
        `;
      } else {
        codeSection = `
          <div style="display: flex; gap: 10px; margin-top: 10px;">
            <div style="flex: 1; border: 1px dashed rgba(217,106,71,0.5); padding: 8px 15px; background: rgba(217,106,71,0.05); color: var(--brand-coral); font-weight: 600; text-align: center; border-radius: 4px;">
              ${offer.discount_code}
            </div>
            <button type="button" class="btn-primary" style="padding: 8px 15px; min-width: 80px; font-size: 0.8rem;" onclick="navigator.clipboard.writeText('${offer.discount_code}'); this.innerText='Copied!'; setTimeout(()=>{this.innerText='Copy'},2000); sessionStorage.setItem('popup_discount_code', '${offer.discount_code}'); if(window.location.pathname.includes('/cart')){setTimeout(()=>window.location.reload(),500);}">Copy</button>
          </div>
        `;
      }
    } else if (offer.button_link && offer.button_label && !isClaimed) {
      codeSection = `
        <a href="${offer.button_link}" class="btn-primary" style="display: block; text-align: center; margin-top: 10px; padding: 10px;">${offer.button_label}</a>
      `;
    }

    var imgHTML = offer.image ? `<div class="offer-card-image" style="background-image: url('${offer.image}');"></div>` : '';

    return `
      <div class="offer-card" style="${isClaimed ? 'opacity: 0.6;' : ''}">
        ${badgeHTML}
        ${imgHTML}
        <div>
          <h4 class="offer-card-headline">${offer.headline}</h4>
          <p class="offer-card-subtext">${offer.subtext}</p>
        </div>
        ${codeSection}
      </div>
    `;
  }

  function renderDrawerList() {
    if (!drawerList) return;
    
    var html = '';
    var unclaimed = offers.filter(o => !claimedOffers.includes(o.id));
    var claimed = offers.filter(o => claimedOffers.includes(o.id));
    
    unclaimed.forEach(o => html += getOfferCardHTML(o, false));
    claimed.forEach(o => html += getOfferCardHTML(o, true));
    
    if (html === '') html = '<p>No offers available at this time.</p>';
    drawerList.innerHTML = html;
  }

  // 5. Popup Rotation Logic
  function closeActivePopup() {
    if (activePopup) {
      activePopup.style.display = 'none';
      document.body.classList.remove('popup_promo_open');
      if (settings.showOncePerSession && !(window.Shopify && window.Shopify.designMode)) {
        sessionStorage.setItem('popup_dismissed_session', 'true');
      }
    }
  }

  // Find the first unclaimed popup
  var targetPopupId = null;
  var targetPopupDelay = 2000;
  
  for (var i = 0; i < offers.length; i++) {
    if (!claimedOffers.includes(offers[i].id)) {
      targetPopupId = offers[i].id;
      targetPopupDelay = offers[i].delay;
      break;
    }
  }

  if (targetPopupId && popups.length > 0) {
    popups.forEach(p => {
      if (p.getAttribute('data-popup-id') == targetPopupId) {
        activePopup = p;
      }
    });

    if (activePopup) {
      var closeBtn = activePopup.querySelector('.popup_promo_close');
      if (closeBtn) closeBtn.onclick = closeActivePopup;
      activePopup.onclick = function(e) { if (e.target === activePopup) closeActivePopup(); };

      // We no longer mark offers as claimed just by clicking copy. 
      // It is only claimed if the backend confirms they used it in an order.

      // Check if dismissed this session
      var sessionDismissed = sessionStorage.getItem('popup_dismissed_session') === 'true';
      if (!sessionDismissed && !(window.Shopify && window.Shopify.designMode)) {
        setTimeout(function() {
          activePopup.style.display = 'flex';
          void activePopup.offsetWidth;
          document.body.classList.add('popup_promo_open');
        }, targetPopupDelay);
      }
    }
  }

  // 6. Cart Page Offers UI
  if (window.location.pathname.includes('/cart')) {
    // Read cart product types (injected by Liquid)
    var cartTypesScript = document.getElementById('cart-product-types');
    var cartProductTypes = [];
    if (cartTypesScript) {
      try {
        cartProductTypes = JSON.parse(cartTypesScript.textContent).map(function(t) {
          return (t || '').toLowerCase().trim();
        });
      } catch(e) {}
    }

    // Filter offers: show all unclaimed offers whose product_type is in cart (or unrestricted)
    function offerApplicableToCart(offer) {
      if (!offer.product_type || offer.product_type.trim() === '') return true; // no restriction
      return cartProductTypes.includes(offer.product_type.toLowerCase().trim());
    }

    var cartOffersHub = document.getElementById('cart-offers-hub');
    if (cartOffersHub) {
      var applicableOffers = offers.filter(function(o) { return o.discount_code && offerApplicableToCart(o); });
      if (applicableOffers.length > 0) {
        renderCartOffers();
      }
    }

    function renderCartOffers() {
      var cartOffersHub = document.getElementById('cart-offers-hub');
      if (!cartOffersHub) return;

      var appliedCode = sessionStorage.getItem('popup_discount_code');
      // Only show offers applicable to what's in the cart
      var offersWithCode = offers.filter(function(o) { return o.discount_code && offerApplicableToCart(o); });

      var html = `
        <div style="border-top: 1px dashed var(--brand-line-d, #e5e0d8); padding-top: 28px; margin-bottom: 5px;">
          <h4 style="font-family: var(--font-sans, sans-serif); font-size: 0.8rem; text-transform: uppercase; letter-spacing: 0.12em; color: var(--text-on-light-muted, #888); margin-bottom: 18px; font-weight: 500;">Available Offers</h4>
          <div style="display: flex; flex-direction: column; gap: 14px;">
      `;

      offersWithCode.forEach(function(offer) {
        var isClaimed = claimedOffers.includes(offer.id);
        var isApplied = appliedCode && appliedCode.toUpperCase() === offer.discount_code.toUpperCase();

        var stateColor = isClaimed ? '#aaa' : isApplied ? '#0f7f6b' : 'var(--brand-coral, #d96a47)';
        var borderColor = isApplied ? 'rgba(15,127,107,0.4)' : isClaimed ? 'rgba(0,0,0,0.08)' : 'rgba(217,106,71,0.25)';
        var bgColor = isApplied ? 'rgba(15,127,107,0.06)' : isClaimed ? 'rgba(0,0,0,0.03)' : 'rgba(217,106,71,0.04)';

        var badgeHTML = '';
        if (isClaimed) {
          badgeHTML = `<span style="background:#aaa;color:white;font-size:0.65rem;text-transform:uppercase;letter-spacing:0.08em;padding:3px 8px;border-radius:30px;font-weight:600;">Used</span>`;
        } else if (isApplied) {
          badgeHTML = `<span style="background:#0f7f6b;color:white;font-size:0.65rem;text-transform:uppercase;letter-spacing:0.08em;padding:3px 8px;border-radius:30px;font-weight:600;">✓ Applied</span>`;
        }

        var actionBtn = '';
        if (!isClaimed) {
          if (isApplied) {
            actionBtn = `<button type="button"
              onclick="sessionStorage.removeItem('popup_discount_code'); if(window.cartOffersRender) window.cartOffersRender(); var b=document.getElementById('cart-discount-banner'); if(b){b.style.display='none';}"
              style="flex-shrink:0;background:none;border:1px solid rgba(15,127,107,0.4);color:#0f7f6b;padding:7px 16px;border-radius:6px;font-size:0.78rem;font-weight:600;cursor:pointer;transition:all 0.2s ease;letter-spacing:0.04em;">
              Remove
            </button>`;
          } else {
            actionBtn = `<button type="button"
              onclick="
                sessionStorage.setItem('popup_discount_code', '${offer.discount_code}');
                if(window.cartOffersRender) window.cartOffersRender();
                var b=document.getElementById('cart-discount-banner');
                if(b){
                  b.innerHTML='<span style=\\'display:flex;align-items:center;gap:10px;\\'><svg width=\\'18\\' height=\\'18\\' viewBox=\\'0 0 24 24\\' fill=\\'none\\' stroke=\\'currentColor\\' stroke-width=\\'2.5\\' stroke-linecap=\\'round\\' stroke-linejoin=\\'round\\'><polyline points=\\'20 6 9 17 4 12\\'></polyline></svg>Offer <strong style=\\'font-family:var(--font-serif);letter-spacing:0.05em;\\'>${offer.discount_code}</strong> will be applied at checkout.</span><button type=\\'button\\' onclick=\\'sessionStorage.removeItem(&quot;popup_discount_code&quot;);location.reload();\\' style=\\'background:none;border:none;font-size:1.2rem;cursor:pointer;color:inherit;opacity:0.7;\\'>&times;</button>';
                  b.style.display='flex';
                }
                var checkoutBtn=document.querySelector('[name=checkout]');
                if(checkoutBtn){
                  checkoutBtn.onclick=function(e){e.preventDefault();var root=(window.Shopify&&window.Shopify.routes)?window.Shopify.routes.root:'/';window.location.href=root+'checkout?discount=${encodeURIComponent(offer.discount_code)}';};
                }
              "
              style="flex-shrink:0;background:var(--brand-coral,#d96a47);color:white;border:none;padding:7px 16px;border-radius:6px;font-size:0.78rem;font-weight:600;cursor:pointer;transition:all 0.2s ease;letter-spacing:0.04em;">
              Apply Offer
            </button>`;
          }
        }

        html += `
          <div style="display:flex;align-items:center;gap:16px;padding:16px 18px;background:${bgColor};border:1px solid ${borderColor};border-radius:10px;transition:all 0.3s ease;${isClaimed ? 'opacity:0.5;' : ''}">
            <div style="flex:1;min-width:0;">
              <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:4px;">
                <span style="font-family:var(--font-serif,serif);font-size:1rem;color:var(--brand-ink,#0f2a33);font-weight:600;">${offer.headline}</span>
                ${badgeHTML}
              </div>
              <p style="font-size:0.82rem;color:var(--text-on-light-muted,#888);margin:0 0 8px;">${offer.subtext || ''}</p>
              <div style="display:inline-flex;align-items:center;gap:6px;background:white;border:1.5px dashed ${stateColor};border-radius:5px;padding:4px 12px;">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="${stateColor}" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>
                <span style="font-size:0.82rem;font-weight:700;letter-spacing:0.1em;color:${stateColor};">${offer.discount_code}</span>
              </div>
            </div>
            ${actionBtn}
          </div>
        `;
      });

      html += '</div></div>';
      cartOffersHub.innerHTML = html;
    }

    // Expose for inline onclick calls
    window.cartOffersRender = renderCartOffers;
  }

  // Init
  updateWidget();

  // Handle Shopify Editor Events
  document.addEventListener('shopify:block:select', function(e) {
    if (activePopup) activePopup.style.display = 'none';
    var selected = document.querySelector('.popup_promo_overlay[data-popup-id="' + e.detail.blockId + '"]');
    if (selected) {
      activePopup = selected;
      activePopup.style.display = 'flex';
      document.body.classList.add('popup_promo_open');
    }
  });
  document.addEventListener('shopify:block:deselect', function(e) {
    if (activePopup) activePopup.style.display = 'none';
    document.body.classList.remove('popup_promo_open');
  });
});
